// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const ACTION_TO_ADD_POST = "pridanie diskusie";
export const TO_action_YOU_HAVE_TO_BE_loggedIn = "Pre %(action)s mus\u00ed\u0161 %(loggedIn)s.";
export const TO_BE_LOGGED_IN = "by\u0165 prihl\u00e1sen\u00e1";
